var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12.65 8.43"}},[_c('path',{attrs:{"d":"M0 4.918h9.979L7.45 7.447l.983.983 4.217-4.215L8.433 0l-.984.984 2.53 2.529H0z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }